import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
// import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

/**
 * A menu sliding in from the left or right side.
 * It should be composed using the following components:
 *
 * <DrawerPanel>
 *     <DrawerPanelPanel>
 *         <DrawerPanelPanelHeader>
 *              ...
 *         </DrawerPanelPanelHeader>
 *         <Backdrop />
 *     </DrawerPanelPanel>
 * </DrawerPanel
 */

const DrawerPanel = (props) => {
    const classNames = classnames('drawerPanel', props.className, props.orientation ? ('drawerPanel--' + props.orientation) : null);

    if (!props.isOpen) {
        return null;
    }

    return <aside className={classNames} aria-label="drawerPanel">{props.children}</aside>;
};

DrawerPanel.propTypes = {
    className: PropTypes.string,
    isOpen: PropTypes.bool.isRequired
};

const DrawerPanelPanel = (props) => {
    const classNames = classnames('drawerPanel__panel');
    return (
        <div className={classNames}>
            {props.children}
        </div>
    )
};

DrawerPanelPanel.propTypes = {
    orientation: PropTypes.oneOf(['right']),
};

const DrawerPanelPanelHeader = (props) => {
    return (
        <div className="drawerPanel__panel__header">

            {props.children}
        </div>
    )
};

const DrawerPanelPanelContent = (props) => {
    return (
        <div className="drawerPanel__panel__content" tabIndex={0} >
            {props.children}
        </div>
    )
};

export default DrawerPanel;
export {DrawerPanelPanel, DrawerPanelPanelHeader, DrawerPanelPanelContent};